import { sleep } from "~/utils"

type BaseFunction = (...args: any[]) => Promise<any>

export type Fetcher<F extends BaseFunction> = F & {
  setMockResponse(mockResponse: Awaited<ReturnType<F>>): void
}

/**
 * fetchの関数を定義する。
 * 定義された関数には、setMockResponseメソッドが定義され、それに対しmockデータをsetするとcall時にapi通信せずにインターセプトされる(主にstorybook用)
 */
export const defineFetcher = <F extends BaseFunction>(callback: F): Fetcher<F> => {
  if (process.env.ENV === "production") {
    return callback as Fetcher<F>
  }
  let maybeMockResponse: ReturnType<F> | undefined = undefined

  const fetcher = (async (...args: any[]) => {
    if (maybeMockResponse) {
      await sleep(1500)
      return maybeMockResponse
    }

    return callback(...args)
  }) as Fetcher<F>

  fetcher.setMockResponse = (mockResponse) => {
    maybeMockResponse = mockResponse
  }

  return fetcher
}
